import { useEffect } from "react";
import { Form, Button, Modal, message, Space, Divider } from "antd";
import Popup from "../Popup";
import DynamicFormFields from "../Form/DynamicFormFields";
import useAxios from "../../hooks/useAxios";

const EditCancelModal = ({
  open,
  item,
  formFields,
  toFormValues,
  submitTransform,
  updateUrl,
  cancelUrl,
  employeeId,
  title,
  popupWidth,
  onClose,
  onUpdated,
}) => {
  const [form] = Form.useForm();
  const { loading: saving, fetchData: fetchUpdate } = useAxios();
  const { loading: cancelling, fetchData: fetchCancel } = useAxios();

  useEffect(() => {
    if (open && item) {
      form.setFieldsValue(toFormValues(item));
    }
  }, [open, item, form, toFormValues]);

  const handleSave = (values) => {
    const requestData = {
      ...(submitTransform ? submitTransform(values) : values),
      employee_id: employeeId,
    };

    fetchUpdate({
      url: `${updateUrl}/${item.id}`,
      method: "POST",
      data: requestData,
    })
      .then(() => {
        message.success("Submission updated.");
        onUpdated?.();
        onClose();
      })
      .catch((error) => {
        const msg =
          error?.response?.data?.message ||
          error?.message ||
          "Update failed. Please try again.";
        message.error(msg);
      });
  };

  const handleCancelSubmission = () => {
    Modal.confirm({
      title: "Cancel this submission?",
      content:
        "This action cannot be undone. The submission will be marked as cancelled.",
      okText: "Yes, Cancel Submission",
      cancelText: "No, Keep It",
      okButtonProps: { danger: true, loading: cancelling },
      centered: true,
      onOk: () =>
        fetchCancel({ url: `${cancelUrl}/${item.id}`, method: "POST" })
          .then(() => {
            message.success("Submission cancelled.");
            onUpdated?.();
            onClose();
          })
          .catch((error) => {
            const msg =
              error?.response?.data?.message ||
              error?.message ||
              "Cancellation failed. Please try again.";
            message.error(msg);
          }),
    });
  };

  return (
    <Popup
      isOpen={open}
      title={`Edit ${title}`}
      onCancel={onClose}
      footer={null}
      width={popupWidth}
      destroyOnClose
    >
      <Form form={form} layout="horizontal" onFinish={handleSave}>
        <DynamicFormFields fields={formFields} form={form} />
        <Divider />
        <Space style={{ display: "flex", justifyContent: "space-between" }}>
          <Button danger onClick={handleCancelSubmission}>
            Cancel Submission
          </Button>
          <Button type="primary" htmlType="submit" loading={saving}>
            Save Changes
          </Button>
        </Space>
      </Form>
    </Popup>
  );
};

export default EditCancelModal;
